import { useEffect, useState } from 'react'
import { Button, Dialog, Flex, Text } from '@radix-ui/themes'

import { useAuth } from '@/hooks/useAuth'

export const SessionWarningModal = () => {
  const { showWarningModal, renewManually, signOut } = useAuth()
  const [countdown, setCountdown] = useState(60)

  useEffect(() => {
    if (!showWarningModal) {
      return
    }

    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1)
    }, 1000)

    const timeout = setTimeout(() => {
      signOut()
    }, 60_000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
      setCountdown(60)
    }
  }, [showWarningModal, signOut])

  if (!showWarningModal) {
    return null
  }

  return (
    <Dialog.Root open>
      <Dialog.Content maxWidth="400px">
        <Dialog.Title align="center">Tu sesión va a expirar</Dialog.Title>
        <Text align="center" mt="2">
          Se cerrará automáticamente en {countdown} segundos.
        </Text>
        <Flex mt="4" justify="center" gap="3">
          <Button variant="soft" onClick={signOut}>
            <Text>Salir</Text>
          </Button>
          <Button onClick={renewManually}>
            <Text>Renovar</Text>
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}
